import FormGridItem from '~/components/FormComponents/FormGridItem.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete.tsx';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAddressQuery } from '~/queries/useAddressQuery.ts';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Box, Grid, Typography } from '@mui/material';
import { AccountHolderStatus } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/OrganizationSelfAssessmentDocumentForm/AccountHolderStatus/AccountHolderStatus.tsx';
import { styles } from '~/modules/identification/styles.ts';
import { TaxResidencyJurisdictions } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/OrganizationSelfAssessmentDocumentForm/TaxResidencyJurisdictions/TaxResidencyJurisdictions.tsx';
import { EMPTY_TAX_RESIDENCY_JURISDICTIONS } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/constants.ts';
import { commonStyles } from '~/theme/styles/commonStyles.ts';
import FormContainer from '~/modules/identification/components/FormComponents/FormContainer.tsx';
import {
  selectGeneralInfoAddress,
  selectShortNameUkr,
} from '~/store/identification-form/selectors.ts';

export const OrganizationSelfAssessmentDocumentForm = () => {
  const { countryOptions } = useAddressQuery();
  const shortNameUkr = useSelector(selectShortNameUkr);
  const address = useSelector(selectGeneralInfoAddress);
  const { setValue, control, getValues } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'taxResidencies',
  });

  if (!fields.length) append(EMPTY_TAX_RESIDENCY_JURISDICTIONS);

  useEffect(() => {
    const registrationJurisdiction = address?.registrationAddress?.country?.label;
    const currentOrganizationName = getValues('organizationName');
    const currentRegistrationJurisdiction = getValues('registrationJurisdiction');
    if (shortNameUkr && currentOrganizationName !== shortNameUkr) {
      setValue('organizationName', shortNameUkr, {
        shouldDirty: currentOrganizationName,
      });
    }
    if (registrationJurisdiction && currentRegistrationJurisdiction !== registrationJurisdiction) {
      setValue('registrationJurisdiction.label', registrationJurisdiction, {
        shouldDirty: currentRegistrationJurisdiction,
      });
    }
  }, [shortNameUkr, address?.registrationAddress?.country, getValues, setValue]);

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormInput
          name="organizationName"
          label="Повне найменування клієнта"
          placeholder="Введіть повне найменування клієнта"
          disabled
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          name="registrationJurisdiction"
          options={countryOptions}
          inputProps={{
            placeholder: 'Оберіть країну реєстрації',
          }}
          label="Країна реєстрації"
          disabled
        />
      </FormGridItem>
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6" sx={styles.titleForm}>
          Вкажіть статус Власника Рахунку, поставивши відмітку в одному з полів
        </Typography>
        <AccountHolderStatus />
      </Box>
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6" sx={styles.titleForm}>
          Держава/ юрисдикція резидентства для цілей оподаткування та відповідний ІПН або його
          функціональний еквівалент
        </Typography>
        <Box sx={commonStyles.columnFlexContainer}>
          <FormContainer hasBookmark>
            {fields.map((tax, index) => (
              <TaxResidencyJurisdictions
                key={tax.id}
                index={index}
                append={append}
                remove={remove}
              />
            ))}
          </FormContainer>
        </Box>
      </Box>
    </Grid>
  );
};
